import React, { FunctionComponent } from 'react';
import './CookiesInformation.css';
import { Grid, GridItem, Link } from '@chakra-ui/react';

type Props = {
  handleClose: () => void;
}

export const Terminal: FunctionComponent<Props> = ({handleClose}) => {
  return (
    <div className="cookies-information">
      <Grid gap={3}>
      {/* <GridItem h="min-content">
       {"[X]"}
      </GridItem> */}
      <GridItem h="min-content">
        =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
      </GridItem>
      <GridItem><p>Welcome to my website!</p></GridItem>
      <GridItem><p>Would you like to keep in contact? Send me a message through <Link href='https://www.linkedin.com/in/dorotazelga' isExternal>LinkedIn</Link>.</p></GridItem>
      {/* <GridItem><p>Explore my other projects on my <Link href="https://github.com/wroclawianka" isExternal>GitHub profile</Link> as well.</p></GridItem> */}
      <GridItem><p>The page includes various easter eggs. Try to find them all!</p></GridItem>
      <GridItem><p>Explore my other projects on my <Link href="https://github.com/wroclawianka" isExternal>GitHub</Link> profile as well.</p></GridItem>
      <GridItem>
        <Grid templateColumns={"repeat(3, 1fr)"}>
          <GridItem><Link onClick={handleClose}>[E]xit</Link></GridItem>
          <GridItem><Link href='https://www.linkedin.com/in/dorotazelga' isExternal>[L]inkedIn</Link></GridItem>
          <GridItem><Link href='https://github.com/wroclawianka' isExternal>[G]itHub</Link></GridItem>
        </Grid>
        
        </GridItem>
      <GridItem h="min-content">
      =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
      </GridItem>
      </Grid>
    </div>
  );
};


// exit
// show when scrolled on the bottom 
// adjust to the mobile